import type { FormFieldValues } from '@jira/issue-create__issue-create-common-types/src/common/types/index.tsx';

/**
 * Normalises a `defaultValues` payload to a stable cache-key-friendly value.
 *
 * The GIC modal load query is keyed by Apollo on its serialised arguments,
 * including `defaultValues`. An empty object (`{}`) and `null` serialise to
 * different cache keys even though they are semantically equivalent to the
 * backend (no field defaults to seed). User-input retention produces `{}` when
 * nothing has been entered, while the initial modal load sends `null`. Without
 * normalisation, revisiting a previously-fetched project/issue type yields a
 * cache miss (and a redundant network call) purely because of this mismatch.
 *
 * Returns `null` for nullish or empty payloads so the no-input case always
 * produces the same cache key; otherwise returns the payload unchanged so
 * genuine retained values still seed the backend response.
 */
export const normalizeDefaultValues = (
	defaultValues: FormFieldValues | null | undefined,
): FormFieldValues | null => {
	if (defaultValues == null || Object.keys(defaultValues).length === 0) {
		return null;
	}
	return defaultValues;
};
